import { render, staticRenderFns } from "./ActivateUser.vue?vue&type=template&id=79cf16da"
import script from "./ActivateUser.vue?vue&type=script&lang=ts"
export * from "./ActivateUser.vue?vue&type=script&lang=ts"
import style0 from "./ActivateUser.vue?vue&type=style&index=0&id=79cf16da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports